import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ContactSection />
        <CarouselSection />
        <CardsSection />
        <FaqSection />
        <FeaturesSection />
        <UpdatesSection />
        <IndexSection />
        <AboutSection />
        <CommentsSection />
        <MediaSection />
        <RankingSection />
        <AppSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}